import { ActionType, createAction } from "typesafe-actions";

import {
  EntitiesSupportingLeadGen,
  EntityTypeSupportingLeadGen,
  Lead,
} from "@mapmycustomers/shared/types/entity";

export const toggleLeadSelection = createAction(
  "route/routeDetails/leadFinder/toggleLeadSelection"
)<Lead["place_id"]>();

export const addLeadsToSelection = createAction(
  "route/routeDetails/leadFinder/addLeadsToSelection"
)<Array<Lead["place_id"]>>();

export const setHighlightedLeads = createAction(
  "route/routeDetails/leadFinder/setHighlightedLeads"
)<Set<Lead["place_id"]>>();

export const clearLeadSelection = createAction(
  "route/routeDetails/leadFinder/clearLeadSelection"
)<void>();

export const setSelectedLeads = createAction("route/routeDetails/leadFinder/setSelectedLeads")<
  Array<Lead["place_id"]>
>();

export const setLeadFinderResultsVisible = createAction(
  "route/routeDetails/leadFinder/setResultsVisible"
)<boolean>();

export const appendCreatedRecordsToDraft = createAction(
  "route/routeDetails/leadFinder/appendCreatedRecordsToDraft"
)<{
  entityIds: Array<EntitiesSupportingLeadGen["id"]>;
  entityType: EntityTypeSupportingLeadGen;
}>();

export type RouteLeadFinderActions = ActionType<
  | typeof addLeadsToSelection
  | typeof appendCreatedRecordsToDraft
  | typeof clearLeadSelection
  | typeof setHighlightedLeads
  | typeof setLeadFinderResultsVisible
  | typeof setSelectedLeads
  | typeof toggleLeadSelection
>;
